var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
import { Getter, Mutation } from 'vuex-class';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpens = {};
        _this.hoverCurrMenu = -1;
        return _this;
    }
    default_1.prototype.applyItem = function () {
        this.$emit('open');
    };
    default_1.prototype.clickItem = function (href) {
        this.$router.push(href || '/');
        var navBody = document.getElementsByClassName('nav-body');
        navBody[0].style.height = 0;
        var navList = document.querySelectorAll('.nav-item');
        navList.forEach(function (item) {
            if (item.children[1]) {
                item.onmouseover = function () {
                    if (item.children[1].className === 'nav-body')
                        item.children[1].style.height = "280px";
                };
                item.onmouseout = function () {
                    if (item.children[1].className === 'nav-body')
                        item.children[1].style.height = 0;
                };
            }
        });
    };
    __decorate([
        Getter
    ], default_1.prototype, "menuList", void 0);
    __decorate([
        Getter
    ], default_1.prototype, "currMenu", void 0);
    __decorate([
        Mutation('SET_MENU_LIST')
    ], default_1.prototype, "setMenuList", void 0);
    default_1 = __decorate([
        Component({
            components: {},
            layout: 'main',
            middleware: 'auth'
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/layouts/main/header.vue
// module id = GFhI
// module chunks = 1 3